import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottomrack',
  templateUrl: './bottomrack.component.html',
  styleUrls: ['./bottomrack.component.css']
})
export class BottomrackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
